module.exports = "dist/images/components-design-separator-control-straight-1.3d6e794.png";